{
  "userSettings": "User Settings",
  "breadcrumb": {
    "users": "Users"
  },
  "notification": {
    "all": "All",
    "unread": "Unread",
    "forwarded": "Forwarded on behalf of <UserHighlight>{{user}}</UserHighlight>"
  },
  "common": {
    "resetColumnWidth": "Reset column width",
    "resetColumnWidths": "Reset column widths",
    "copiedToTranslations": "Copied to translations",
    "copyFromDefault": "Copy from default field",
    "copied": "Copied",
    "clickToCopy": "Click to copy",
    "actions": {
      "saveAndProceed": "Save and continue",
      "proceedWithoutChanges": "Continue without saving",
      "continueEditing": "Continue editing",
      "stayOnPage": "Stay on the page",
      "stayOnForm": "Stay on the form"
    },
    "dateOfActivation": "Date of Activation",
    "dateOfDeactivation": "Date of Deactivation",
    "buttonName": "Button Name",
    "dateMask": "DD.MM.YYYY",
    "error": "Error",
    "errorPage": {
      "somethingWentWrong": "Oops!",
      "tryAgainLater": "Something went wrong. Try reloading the page or go back to the home page.",
      "reloadPage": "Reload page",
      "goHome": "Go to home page",
      "copyFullStackTrace": "Copy full stack trace",
      "copied": "Copied!"
    },
    "loading": "Loading...",
    "share": "Share",
    "invalidGuid": "Invalid GUID",
    "activate": "Activate",
    "add": "Add",
    "addAll": "Add All",
    "addColumn": "Add Column",
    "addModule": "Add Module",
    "agenda": "Agenda",
    "childModule": "Child Module",
    "addRole": "Add Role",
    "bulkAddRoles": "Bulk Add Roles",
    "bulkAddRolesModalTitle": "Bulk Role Assignment",
    "bulkAddRolesPreview": "Assigned {{assigned}} roles.",
    "sortById": "Sort by ID",
    "bulkAddUsers": "Bulk Add Users",
    "noUsersFound": "No users found",
    "addRow": "Add Row",
    "transferRoles": "Transfer Roles",
    "addTab": "Add Tab",
    "addSubTab": "Add Tab as subsection",
    "selectParentSection": "Select parent section",
    "noSectionsOnTab": "There are no sections on this tab. Create a section first.",
    "selectTab": "Select tab",
    "selectSubTab": "Select sub-tab",
    "subTab": "Sub-tab",
    "subTabDefault": "Main",
    "subTabNew": "New sub-tab",
    "tab": "Tab",
    "tabName": "Tab name",
    "subTabName": "Sub-tab name",
    "addUser": "Add User",
    "advanceFilter": "Advanced Filtering",
    "again": "Again",
    "agendaName": "Agenda Name",
    "agendaRoles": "Agenda Roles",
    "aggregationGroups": "Aggregation Groups",
    "and": "and",
    "archivate": "Archivate",
    "atLeastOneRequired": "At least one checkbox must be checked",
    "attributeName": "Attribute Name",
    "author": "Author",
    "back": "Back",
    "byUser": "by user",
    "button": "Button",
    "cancel": "Cancel",
    "checkbox": "Checkbox",
    "close": "Close",
    "color": "Color",
    "columns": "Columns",
    "aggregation": "Aggregation",
    "grouping": "Grouping",
    "pinLeft": "Pin Left",
    "pinRight": "Pin Right",
    "comingSoon": "Coming Soon",
    "conditions": "Conditions",
    "massChanges": "Mass Changes",
    "logs": "Logs",
    "confirm": "Confirm",
    "create": "Create",
    "isKey": "Is key",
    "isRequired": "is a required field",
    "mustBeNumber": "must be a number",
    "clear": "Clear",
    "none": "None",
    "noneMale": "None",
    "sum": "Sum",
    "average": "Average",
    "minimum": "Minimum",
    "maximum": "Maximum",
    "count": "Count",
    "copy": "Copy",
    "copyRow": "Copy Row",
    "dataModel": "Data Model",
    "printConfigurations": "Print Configurations",
    "update": "Update",
    "no": "No",
    "notFilled": "Not filled",
    "notSelected": "Not selected",
    "yes": "Yes",
    "selectAnItem": "Select an item",
    "openInNewTab": "Open in new tab",
    "versions": {
      "button": "Versions",
      "currentVersion": "Current Version",
      "createdBy": "Created by",
      "at": "at",
      "lastUpdateBy": "Updated by",
      "noVersionsAvailable": "No versions available",
      "restore": "Restore version",
      "preview": "Preview",
      "substitutedBy": "in substitute mode. Substituting user:",
      "substitutedByShort": "substituted by:",
      "modal": {
        "title": "Record versions",
        "currentVersion": "Current version id:"
      }
    },
    "user": {
      "withoutName": "Without Name"
    },
    "date": {
      "_": "Date",
      "day": "Day",
      "month": "Month",
      "time": "Time",
      "today": "Today",
      "year": "Year"
    },
    "dateTimeCalendar": "Select a date and time",
    "deactivate": "Deactivate",
    "deactive": {
      "message": "By confirming, the user's access credentials will be deactivated."
    },
    "delete": "Delete",
    "deleted": {
      "roles": "Role was successfully deactivated"
    },
    "download": "Download",
    "downloadAll": "Download all",
    "downloadSuccess": "The file was downloaded successfully",
    "failedToDownload": "Failed to download",
    "draft": "Draft",
    "edit": "Edit",
    "editable": "Editable",
    "editRow": "Edit row",
    "editValidFrom": "Edit Valid From",
    "editValidUntil": "Edit Valid Until",
    "email": "Email",
    "empty": "Empty",
    "contactEmail": "Contact Email",
    "reference": "Reference",
    "export": "Export",
    "filterBy": "Filter By",
    "filters": "Filters",
    "from": "From",
    "to": "To",
    "files": "Files",
    "file": "File",
    "flow": {
      "_": "Flow",
      "approval": "Approval Flow",
      "runFunction": "Run Function Flow",
      "archive": "Archive Flow",
      "comment": "Comment Flow",
      "create": "Record Creation Flow",
      "delete": "Deletion Flow",
      "edit": "Record Edit Flow",
      "history": "History Flow",
      "read": "Read Flow",
      "title": "Flow"
    },
    "flowApproval": "Flow Approval",
    "flowArchive": "Flow Archive",
    "flowComment": "Flow Comment",
    "flowCreate": "Flow Create",
    "flowDelete": "Flow Delete",
    "flowHistory": "Flow History",
    "flowRead": "Flow Read",
    "form": "Form",
    "personalSettings": "Personal Settings",
    "grid": "Grid",
    "helios": {
      "_": "Helios",
      "copy": "Helios Copying",
      "copyLine": "Helios Line Copying",
      "create": "Helios Creation",
      "createLine": "Helios Line Creation",
      "delete": "Helios Deletion",
      "edit": "Helios Editing",
      "editLine": "Helios Line Editing",
      "export": "Helios Table Export",
      "title": "Helios",
      "saved": "Successfully Saved"
    },
    "Helios": {
      "edit": "Helios Editing"
    },
    "heliosCopy": "Helios Copy",
    "heliosCopyLine": "Helios Copy Line",
    "heliosCreate": "Helios Create",
    "heliosCreateLine": "Helios Create Line",
    "heliosDelete": "Helios Delete",
    "heliosEditLine": "Helios Edit Line",
    "heliosExport": "Helios Export",
    "hidden": "Hidden",
    "icon": "Icon",
    "removeIcon": "Remove icon",
    "individualChoice": "Individual choice",
    "infinitive": "Unlimited",
    "invalidEmail": "Invalid Email",
    "invalidInput": "Invalid input",
    "invalidPhoneNumber": "Invalid phone number",
    "isUnique": "Unique",
    "lastModified": "Last modified:",
    "maxLength": "Max. number of allowed letters",
    "maxSize": "Your file is larger than",
    "maxValue": "Value must be less than or equal to: ",
    "minValue": "Value must be greater than or equal to: ",
    "rangeValue": "Value must be in the range {{min}} to {{max}}",
    "multiSelectOption": "Multi-select option",
    "notSave": "Do not save",
    "previous": "Previous",
    "next": "Next",
    "noEdits": "No changes to save",
    "name": "Name",
    "name_cs": "Name (CZ)",
    "name_en": "Name (EN)",
    "name_sk": "Name (SK)",
    "label_cs": "Label (CZ)",
    "label_en": "Label (EN)",
    "label_sk": "Label (SK)",
    "noCorrectPattern": "Invalid Format",
    "noData": "No Data",
    "noFiles": "No Files",
    "noIcon": "No icons found",
    "noRequiredField": "This field does not need to be filled in",
    "noSelected": "Not Selected",
    "number": "Number",
    "operation": "Operation",
    "options": "Options",
    "or": "or",
    "organization": "Organization",
    "outOf": "of",
    "phoneNumber": "Phone",
    "placeholder": {
      "columnName": "Column Name",
      "email": "User Email",
      "contactEmail": "User Contact Email",
      "reference": "Reference",
      "icon": "Select Icon",
      "multilangName": "Name",
      "name": "User Name",
      "name_cs": "Name (CZ)",
      "name_en": "Name (EN)",
      "name_sk": "Name (SK)",
      "role": "New Role Name",
      "rowCount": "Number of Rows"
    },
    "preview": "Preview",
    "publish": "Publish",
    "required": "Required Field",
    "selectedItems": "Selected items",
    "removeItem": "Remove {{item}}",
    "richText": {
      "sizeSmall": "Small",
      "sizeNormal": "Normal",
      "sizeLarge": "Large",
      "sizeHuge": "Huge",
      "fontSansSerif": "Sans Serif",
      "fontSerif": "Serif",
      "fontMonospace": "Monospace",
      "tooltipVisitUrl": "Visit URL:",
      "tooltipEdit": "Edit",
      "tooltipSave": "Save",
      "tooltipRemove": "Remove",
      "tooltipEnterLink": "Enter link:",
      "promptEnterUrl": "Enter the valid URL: (https://www.example.com)"
    },
    "requiredWithFieldName": "Field \"{{fieldName}}\" is required",
    "requiredWithFieldNameAndCount": "Field \"{{fieldName}}\" is required ({{count}}x)",
    "diactricCharactersNotAllowed": "Diactric characters are not allowed",
    "role": {
      "added": "Role was successfully added"
    },
    "roles": {
      "_": "Roles",
      "": "Editing",
      "approval": "Approval",
      "archive": "Archiving",
      "comment": "Commenting",
      "copy": "Copying",
      "copyLine": "Copy Line",
      "create": "Creation",
      "createLine": "Line Creation",
      "delete": "Deletion",
      "edit": "Editing",
      "editLine": "Line Editing",
      "export": "Export",
      "history": "History",
      "read": "Reading"
    },
    "rowControls": "Row Controls",
    "rowCount": "Number of Rows",
    "refresh": "Refresh",
    "refreshCooldown": "Refresh ({{seconds}}s)",
    "save": "Save",
    "saveDraft": "Save draft",
    "saveAndClose": "Save and Close",
    "search": {
      "_": "Search",
      "icons": "search in icons",
      "modules": "Search in Modules",
      "modulesAndAgendas": "Search in Modules and Agendas",
      "notificationTemplates": "Search in notification templates",
      "roles": "Search in Roles",
      "records": "Search in records",
      "tables": "Search in Tables",
      "users": "Search in Users",
      "dataSources": "Search data sources",
      "substitutions": "Search in Substitutions"
    },
    "selectedUsers": "Selected users",
    "selectedRoles": "Selected roles",
    "noRolesFound": "No roles found",
    "section": "Section",
    "sectionName": "Section name",
    "parentSectionName": "Parent section name",
    "collapsed": "Show section as collapsed",
    "description": "Description",
    "select": "Select",
    "selected": "Selected",
    "selectValue": "Select Value",
    "settings": "Settings",
    "settingsAdmin": "Settings Admin",
    "showAll": "show all",
    "loadMore": "Show more",
    "showingRecords": "Showing {{shown}} of {{total}} records",
    "state": "State",
    "stateLabels": {
      "draft": "Draft",
      "active": "Active",
      "disable": "Disabled"
    },
    "source": "Source",
    "sourceType": {
      "createdDate": "Created",
      "dateNow": "Today",
      "emptyValue": "Empty Value",
      "formItem": "Form Item",
      "realUserId": "Real User Id",
      "updatedDate": "Updated",
      "userEmail": "User Email",
      "userId": "User Id",
      "userRole": "User Role",
      "userContactEmail": "User Contact Email",
      "userReference": "User Reference"
    },
    "specialChar": "Special Character",
    "success": "Successfully Sent",
    "tableControls": "Table Controls",
    "tellNumber": "Tell Number",
    "emailWithUserId": "Email with User ID",
    "templatesAdmin": "Templates Admin",
    "text": "Text",
    "textField": "Text Field",
    "title": "Title",
    "type": "Type",
    "unique": "Unique",
    "isActionInput": "Attributes editable in detail",
    "isParentInput": "Parent input",
    "updateDateOfActivation": "Update Date of Activation",
    "updateDateOfDeactivation": "Update Date of Deactivation",
    "upload": "Upload",
    "uploadFileSuccess": "File was successfully uploaded",
    "uploadFileError": "An error occurred while uploading the file",
    "uploadFromGoogle": "Attach from Google Drive",
    "usable": "Usable",
    "userDefinedField": "User defined field",
    "userDetails": "User Details",
    "userInfo": "User Info",
    "usernamePlaceholder": "User",
    "usersAdmin": "Templates User",
    "userSettings": "User Settings",
    "validFrom": "Valid from",
    "validUntil": "Valid until",
    "value": "Value",
    "view": "View",
    "viewRoles": "View Roles",
    "visible": "Visible",
    "visibleinmenu": "Visible",
    "warning": "Warning",
    "write": "Write",
    "widget": "Widget",
    "helper": {
      "conditions": "Conditions"
    },
    "maxLengthLimited": "Max. number of allowed letters (no more than 1000)",
    "maxLengthError": "Input can contain at most {{count}} characters.",
    "visibilityName": "Visibility Name",
    "startValue": "Start Value",
    "defaultValue": "Default Value",
    "defaultValueSource": "Default selected Value",
    "offsetDays": "Days offset",
    "offsetDaysHelp": "Number of days added to current date (negative = past)",
    "favorite": "Add to favorites",
    "unfavorite": "Remove from favorites"
  },
  "filters": {
    "title": "Filters",
    "savedFilters": "Saved filters",
    "selectSavedFilter": "Select saved filter",
    "reset": "Reset",
    "apply": "Confirm",
    "editFilter": {
      "title": "Edit filter"
    },
    "created": "A new filter has been created",
    "updated": "The filter has been updated",
    "deleted": "The filter has been deleted",
    "nestedLevelWarning": "To filter by 2nd level of nesting (items of items), you must enable column display in filter results",
    "saveFilter": {
      "title": "Save filter",
      "name": "Filter name",
      "placeholder": "Enter filter name",
      "save": "Save",
      "default": "Default",
      "global": "Available to everyone"
    }
  },
  "form": {
    "section": {
      "error": {
        "duplicate": "Cell name must be unique",
        "remove_col": "Cannot remove column because it contains items",
        "remove_row": "Cannot delete row because it contains items"
      },
      "grid": {
        "delete_row": "Deleting row {{index}}",
        "delete_col": "Deleting column {{index}}",
        "rows": "Rows",
        "columns": "Columns",
        "validation": {
          "valid": "Position is valid",
          "out_of_bounds": "Outside of grid",
          "collision_multiple": "Collision with multiple items",
          "collision_single": "Overlaps an item",
          "size_mismatch": "Different item size"
        }
      }
    }
  },
  "languages": {
    "cs": "Czech",
    "en": "English",
    "sk": "Slovak",
    "translateToLangauge": {
      "cs": "Czech",
      "en": "English",
      "sk": "Slovak"
    }
  },
  "login": {
    "error": {
      "unknown": "An error occurred. Please try again later."
    },
    "login": {
      "google": "Sign in with Google",
      "microsoft": "Sign in with Microsoft",
      "subtitle": {
        "google": "Sign in with your Google account or enter your details",
        "microsoft": "Sign in with your Microsoft account or enter your details"
      }
    },
    "pin": {
      "forgotPin": "Forgot PIN?",
      "login": "Log in",
      "subtitle": "Enter your PIN to log into your account"
    },
    "stayLoggedIn": "Stay Logged In",
    "title": "Login"
  },
  "modal": {
    "sourceSelect": {
      "title": "Select Source"
    }
  },
  "modulesAndAgendas": {
    "moduleSelect": {
      "required": "Module is required"
    }
  },
  "sidebar": {
    "admin": {
      "core": {
        "_": "Core",
        "appSettings": "Application Settings",
        "assistants": "Assistants",
        "modules": "Modules",
        "roles": "Roles",
        "substitutability": {
          "_": "Substitutability",
          "detail": "Substitution detail"
        },
        "users": "Users"
      },
      "flow": {
        "_": "Flow",
        "agendaImports": {
          "_": "Import agendas"
        },
        "modules&agendas": {
          "_": "Modules and Agendas",
          "create": "Create agendas",
          "edit": "Edit agendas",
          "view": "View"
        },
        "notification": "Notification Templates",
        "restApiConnections": "Rest api connections",
        "tables": {
          "_": "Tables",
          "view": "View"
        }
      },
      "helios": {
        "_": "Helios",
        "dataSource": "Data Sources",
        "functions": "Functions",
        "tables": "Tables",
        "templates": "Templates",
        "notification": "Notification Templates",
        "templatesImport": "Import Templates"
      }
    },
    "adminZone": "Admin zone",
    "core": {
      "appSettings": "Application Settings",
      "assistants": "Assistants",
      "modules": "Modules",
      "roles": "Roles",
      "users": "Users"
    },
    "flow": {
      "agendas": "Agendas",
      "modulesAndAgendas": {
        "_": "Modules and Agendas",
        "create": "Create Module",
        "edit": "Edit Module",
        "view": "View"
      },
      "notification": "Notification Templates",
      "tables": "Tables"
    },
    "helios": {
      "dataSource": "Data Sources",
      "functions": "Functions",
      "tables": "Tables",
      "templates": "Templates"
    },
    "logout": "Logout",
    "feedback": "Send feedback",
    "profile": "Profile",
    "userSettings": "User Settings",
    "substitutes": "Substitutes",
    "substitutesTabs": {
      "planned": "Planned substitutions",
      "substituteUser": "Substitute user",
      "detail": "Substitution Detail",
      "columns": {
        "substitutionType": "Substitution Type",
        "dateFrom": "Date From",
        "dateTo": "Date To",
        "absentUser": "Substituted User",
        "absentUserEmail": "Substituted Email",
        "substituteUser": "Substitute User",
        "substituteUserEmail": "Substitute Email",
        "roles": "Roles"
      }
    },
    "user": {
      "action": "Pending tasks",
      "applicationsAndModules": "Applications / Modules",
      "contacts": "Distribution list",
      "info": "Unread information",
      "overview": "Overview",
      "yourModules": "Your Modules"
    },
    "userZone": "User zone"
  },
  "table": {
    "buttons": {
      "add": "Add",
      "exportCsv": "Export to CSV",
      "delete": "Delete",
      "edit": "Edit",
      "importFunctions": "Import functions"
    },
    "common": {
      "selectDateRange": "Validity"
    },
    "footer": {
      "rowsPerPage": "Rows per page"
    },
    "header": {
      "classId": "Class ID",
      "created": "Created",
      "createdBy": "Created By",
      "creator": "Creator",
      "dateOfActivation": "Date of Activation",
      "dateOfChange": "Date of Change",
      "dateOfDeactivation": "Date of Deactivation",
      "dateOfExport": "Date of Export",
      "dateOfImport": "Date of Import",
      "email": "Email",
      "contactEmail": "Contact Email",
      "exists": "Exists",
      "flow": "Flow",
      "folderId": "Folder ID",
      "fullName": "Full Name",
      "helios": "Helios",
      "icon": "Icon",
      "id": "ID",
      "lastChangedDate": "Last Changed Date",
      "moduleName": "Module Name",
      "module": "Module",
      "name": "Name",
      "name_Cz": "Name (CZ)",
      "name_En": "Name (EN)",
      "name_Sk": "Name (SK)",
      "numberOfColumns": "Number of Columns",
      "numberOfRows": "Number of Rows",
      "reference": "Reference",
      "role": "Role",
      "roleName": "Role Name",
      "roles": "Roles",
      "assignedRoles": "Assigned Roles",
      "assistants": "Assistants",
      "permissions": "Permissions",
      "detail": "Detail",
      "rowCount": "Number of Rows",
      "schema": "Schema",
      "status": "Status",
      "tags": "Tags",
      "userName": "User Name",
      "validFrom": "Valid From",
      "validity": "Validity",
      "validTo": "Valid To",
      "value": "Value",
      "views": "Views",
      "visibility": "Visibility",
      "tableName": "Table Name",
      "userSettings": "User Settings",
      "dataSources": "Data Sources",
      "agendaName": "Agenda Name",
      "updated": "Updated",
      "authorOfCurrentVersion": "Author of Current Version",
      "dataSource": "Data Source",
      "type": "Type",
      "loginUrl": "Login URL",
      "domainUrl": "Domain URL",
      "googleUrl": "Google URL",
      "profile": "Profile",
      "timeZoneId": "Time Zone",
      "column": "Column",
      "database": "Database",
      "item": "Item",
      "parentColumn": "Parent Column",
      "general": "General",
      "wslUrlBasic": "Basic URL",
      "wsUrlDomain": "Domain URL",
      "wsUrlGoogle": "Google URL",
      "wsProfile": "Profile",
      "valid": "Valid",
      "maxConcurrentConnections": "Max Concurrent Connections",
      "isCommon": "Is Common",
      "datasourceName": "Data Source",
      "isRecordFunction": "Record Function",
      "heliosFunctionId": "Helios ID",
      "number": "ID",
      "alias": "Alias",
      "description": "Description",
      "label": "Label",
      "vsgAssistantId": "Assistant ID",
      "subject": "Subject",
      "baseUrl": "Base URL",
      "authType": "Auth Type",
      "isConnected": "Connected"
    },
    "status": {
      "active": "Active",
      "archived": "Archived",
      "design": "Design",
      "draft": "Draft",
      "inactive": "Inactive",
      "invited": "Invited",
      "inprocess": "In Process",
      "imported": "Imported",
      "new": "New",
      "pending": "Pending",
      "online": "Online",
      "offline": "Offline",
      "unknown": "Unknown",
      "success": "Success",
      "failed": "Failed",
      "created": "Created",
      "updated": "Updated"
    }
  },
  "toast": {
    "version": {
      "restored": "Version was successfully restored",
      "error": "An error occurred while restoring the version"
    },
    "activated": {
      "users": "User was successfully activated",
      "usersFromRole": "Users were successfully added"
    },
    "added": {
      "record": "Record was successfully added",
      "rolesToUser": "Roles were successfully added",
      "rolesToUsersBulk": "Successfully assigned {{assigned}} roles, {{users}} users. {{skipped}} duplicates skipped.",
      "rolesToUsersBulk_all": "Assigned {{assigned}} roles, {{users}} users",
      "rolesToUsersBulk_partial": "Assigned {{assigned}} roles, {{users}} users. {{skipped}} duplicates skipped",
      "rolesToUsersBulk_allSkipped": "All selected roles were already assigned to users.",
      "rolesToTemplatesBulk": "Assigned {{assigned}} roles, {{templates}} templates.",
      "user": "User was successfully added",
      "usersToRole": "Users were successfully added"
    },
    "calculated": {
      "error": "An error occurred while recalculating the record"
    },
    "dashboard": {
      "created": "Dashboard was successfully created",
      "deleted": "Dashboard was successfully deleted",
      "updated": "Dashboard was successfully updated",
      "createFailed": "Error while creating dashboard",
      "deleteItemFailed": "Cannot remove item: Invalid ID"
    },
    "deactivated": {
      "users": "User was successfully deactivated",
      "usersFromRole": "Users were successfully removed"
    },
    "deleted": {
      "import": "Imports were successfully removed",
      "rolesFromUser": "Roles were successfully removed",
      "usersFromRole": "Users were successfully removed"
    },
    "module": {
      "created": "Module was successfully created",
      "deleted": "Modules have been successfully deleted",
      "updated": "Module was successfully updated",
      "createFailed": "Error while creating module",
      "noData": "Module contains no data",
      "missingId": "Module is missing ID",
      "deleteFailed": "Error while deleting module",
      "updateFailed": "Error while updating module"
    },
    "assistant": {
      "created": "Assistant was successfully created",
      "updated": "Assistant was successfully updated",
      "deleted": "Assistant was successfully deleted",
      "createFailed": "Error while creating assistant",
      "updateFailed": "Error while updating assistant",
      "deleteFailed": "Error while deleting assistant"
    },
    "modules": {
      "orderUpdated": "Module order was successfully updated"
    },
    "saved": {
      "user": "User was successfully saved"
    },
    "updated": {
      "record": "Record was successfully updated",
      "role": "Role was successfully updated",
      "rolesToUser": "Roles were successfully updated",
      "widget": "Widget was successfully updated",
      "validFrom": "Valid from was successfully updated",
      "validUntil": "Valid until was successfully updated",
      "error": "There were some errors while saving the record"
    },
    "archived": {
      "agendas": "Agenda was successfully archived"
    },
    "record": {
      "shared": "Record was successfully shared",
      "error": "An error occurred while restoring the version"
    },
    "transfered": {
      "roles": "Roles were successfully transferred"
    },
    "action": {
      "completed": "Action completed successfully",
      "loadFailed": "Action '{{actionType}}' could not be loaded due to corrupted data"
    },
    "error": {
      "action": "Action failed",
      "save": "An error occurred while saving",
      "invalidBreadcrumbStructure": "Invalid breadcrumb structure"
    }
  },
  "search": {
    "_": "Search",
    "noResults": "No results found",
    "failed": "Failed to load search results"
  },
  "view": {
    "added": "View was successfully added",
    "successfully": {
      "deleted": "View was successfully deleted"
    },
    "table": {
      "add": "Add View",
      "addColumn": "Add Column",
      "comparisonType": "Select comparison",
      "Contains": "Contains",
      "edit": "Edit View",
      "HasCountOf": "Has count of",
      "HasNotCountOf": "Has not count of",
      "IsBigger": "Is bigger",
      "IsBiggerBy": "≧ source +/- value",
      "IsEmpty": "Is empty",
      "IsEqual": "Is equal",
      "IsNotEmpty": "Is not empty",
      "IsNotEqual": "Is not equal",
      "IsSmaller": "Is smaller",
      "IsSmallerBy": "≦ source +/- value",
      "name": "View Name",
      "None": "None",
      "noneColumnError": "At least one column must be selected",
      "NotContains": "Does not contain",
      "oneEnabledColumnError": "The table must have at least one enabled column",
      "variable": "Variable",
      "filtering": "Filtering",
      "editable": "Interactive",
      "IsPressed": "Is pressed",
      "IsChecked": "Is checked",
      "IsUnchecked": "Is unchecked"
    }
  },
  "substitution": {
    "titleNew": "New Substitution",
    "titleEdit": "Edit Substitution",
    "allUsersTableTitle": "All User Substitutions",
    "fields": {
      "substitutionType": "Substitution Type",
      "dateFrom": "Date From",
      "dateTo": "Date To",
      "substituteUser": "Substitute User",
      "roles": "Roles",
      "permanentSubstitution": "Permanent Substitution",
      "allowNotificationRedirect": "Send notifications to the representative"
    },
    "modal": {
      "delete": {
        "title": "Delete Substitution",
        "message": "Are you sure you want to delete this substitution?",
        "rows": "Are you sure you want to delete the selected substitutions?"
      }
    },
    "errors": {
      "cannotDeleteActiveOrPastSubstitution": "Cannot delete active or past substitution"
    },
    "selectUser": "Select a user",
    "selectAbsentUser": "Select absent user",
    "selectRoles": "Select roles",
    "searchRoles": "Search roles or tags...",
    "rolesWithoutTags": "Roles without tags",
    "tags": "Tags",
    "roles": "Roles",
    "noSubstitutingUsersAvailable": "No substituting users available for your roles",
    "noRolesSelected": "No roles selected",
    "noUsersToSubstitute": "No users available to substitute",
    "selectUserToSubstitute": "Select user to substitute",
    "activateSubstitution": "Activate Substitution",
    "type": {
      "absence": "Absence",
      "substitution": "Substitution"
    },
    "successfullyDeleted": "Substitution was successfully deleted"
  }
}
